const doc = [({"da":({"js":({"nemoa":({"layout":({"top_menu":({"index":({"sign_in":"Log ind"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;